






import { ClientAccount } from '@/shared/clients/client-account';
import { User } from '@/shared/user';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const userModule = namespace('user');
const usersModule = namespace('users');

@Component
export default class LockedWarning extends Vue {
    @userModule.Getter('user') private currentUser!: User | null;

    @usersModule.Getter('users') private users!: Array<User>;

    @Prop({ required: true }) public client!: ClientAccount;

    private get userName(): string {
        if (this.client.lockedBy === this.currentUser!.id!) {
            return 'You have';
        }

        const user = this.users.find((u) => u.id === this.client.lockedBy);
        return user == null ? 'Another user has' : `${user.firstName == null ? '' : user.firstName.trim()} ${user.lastName == null ? '' : user.lastName.trim()} has`;
    }
}
